import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums/reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPrefix } from "features/Application/slices/models";
import accountsDataService from "features/Accounts/services/accountsDataService";

export const accountsTagsStatePrefixPayload = {
  namespace: ReducerNamespaceTypes.Accounts,
  entity: ReducerEntityPrefixTypes.Accounts,
  name: "tags",
};

export const fetchAccountsTags = createAsyncThunk(
  getPrefix(accountsTagsStatePrefixPayload),
  async (includeBsi: boolean) => {
    const items = await accountsDataService.getAccountsTags(includeBsi);

    return { items, totalCount: items.length };
  },
);
